import { Divider, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import type { ColorCieLab } from "./color-math";

export interface FormatColorProps {
  color: ColorCieLab;
}

export const FormatColor: FC<FormatColorProps> = ({ color }) => {
  return (
    <Stack direction="row" spacing={1} display="inline-flex">
      <Typography variant="label">L*</Typography>
      <span>{color[0].toFixed(1)}</span>
      <Divider orientation="vertical" variant="middle" flexItem />
      <Typography variant="label">a*</Typography>
      <span>{color[1].toFixed(1)}</span>
      <Divider orientation="vertical" variant="middle" flexItem />
      <Typography variant="label">b*</Typography>
      <span>{color[2].toFixed(1)}</span>
    </Stack>
  );
};

export function formatColorText(color: ColorCieLab): string {
  const separator = " ｜ ";
  return [
    `L* ${color[0].toFixed(1)}`,
    `a* ${color[1].toFixed(1)}`,
    `b* ${color[2].toFixed(1)}`,
  ].join(separator);
}

export function formatColorDifference(difference: number, unit: string = "") {
  return difference.toFixed(1) + unit;
}
